<template>
  <Manual/>
</template>

<script>
  import { mapState } from 'vuex';
  import LoadingState from '@/api/LoadingState';
  import Manual from '../components/Manual'

  export default {
    name: 'ManualPage',

    components: {
      Manual,
    },
    computed: {
      ...mapState({
      })
    },
    mounted() {
    }
  }
</script>
